import type { LocalDate } from "@freightsimple/time/branded-types";
import { Date } from "../DateTime/Display/Date";
import { T } from "../Typography/T";

type DateCellColor =
  | "default"
  | "muted"
  | "secondary"
  | "green"
  | "red"
  | "orange";

interface DateCellProps {
  /** ISO date string — renders em dash if undefined */
  date: LocalDate | undefined;
  /** Format preset or custom dayjs format string (default: "medium") */
  format?: string | undefined;
  /** Show relative time below the date (e.g. "3 days ago") */
  relative?: boolean | undefined;
  /** Text color override */
  color?: DateCellColor;
}

export function DateCell({
  date,
  format = "medium",
  relative,
  color,
}: DateCellProps) {
  if (!date) {
    return (
      <T color="faint" size="xs">
        {"\u2014"}
      </T>
    );
  }

  const colorProp = color ? { color } : {};

  if (!relative) {
    return (
      <T size="xs" weight="medium" {...colorProp}>
        <Date value={date} format={format} />
      </T>
    );
  }

  return (
    <div className="flex flex-col gap-0.5">
      <T size="xs" weight="medium" {...colorProp}>
        <Date value={date} format={format} />
      </T>
      <div>
        <Date value={date} relativeOnly />
      </div>
    </div>
  );
}
